import axiosInstance from './axiosInstance';

const BASE = (pid) => `/plants/${pid}/vendors`;

export const getAllVendors = async (pid, params) => {
  return await axiosInstance.get(BASE(pid), { params });
};

export const createVendor = async (pid, data) => {
  return await axiosInstance.post(BASE(pid), data);
};

export const updateVendor = async (pid, vid, data) => {
  return await axiosInstance.put(`${BASE(pid)}/${vid}`, data);
};

export const deleteVendor = async (pid, vid) => {
  return await axiosInstance.delete(`${BASE(pid)}/${vid}`);
};

export const searchVendors = async (pid, q) => {
  return await axiosInstance.get(`${BASE(pid)}/search`, { params: { q } });
};